import { create } from 'zustand';

/**
 * Pulso de navegação: quando um card é enviado para a Produção (handoff da
 * Inteligência), a aba "Produção" pisca com contraste por alguns segundos para
 * chamar a atenção do operador. Estado global e efêmero (não persiste).
 */
interface NavPulseState {
  producao: boolean;
  pulseProducao: () => void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

export const useNavPulse = create<NavPulseState>((set) => ({
  producao: false,
  pulseProducao: () => {
    set({ producao: true });
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => set({ producao: false }), 3200);
  },
}));
